import { Result } from "antd";

export const NotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Dieser Link scheint nicht korrekt zu sein."
    />
  );
};
